/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApAdBnrGetResponseApiFrom } from '../../models/ap-ad-bnr-get-response-api-from';

export interface ApiV3ServiceApAdBnrGetGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * ID of the requested banner
 */
  id?: string;
}

export function apiV3ServiceApAdBnrGetGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceApAdBnrGetGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ApAdBnrGetResponseApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceApAdBnrGetGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApAdBnrGetResponseApiFrom>;
    })
  );
}

apiV3ServiceApAdBnrGetGet.PATH = '/api/v3/service/ApAdBnrGet';
